"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "TableDemonstrative", {
  enumerable: true,
  get: function get() {
    return _TableDemonstrative.default;
  }
});
var _TableDemonstrative = _interopRequireDefault(require("./TableDemonstrative.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }